import {createStore, applyMiddleware} from "redux"
import reducers from "../reducers";
import {composeWithDevTools} from "redux-devtools-extension"
import thunkMiddleware from "redux-thunk";

export let Store = createStore(reducers, composeWithDevTools(
    applyMiddleware(thunkMiddleware)
));